var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-11{fill:none}.cls-2{fill:#696c80}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15451",
    "data-name": "Group 15451",
    transform: "translate(-899 -103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18734",
    "data-name": "Rectangle 18734",
    className: "cls-11",
    width: 36,
    height: 36,
    rx: 10,
    transform: "translate(899 103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18241",
    "data-name": "Rectangle 18241",
    className: "cls-11",
    transform: "translate(910 114)",
    d: "M0 0h15v14H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15447",
    "data-name": "Group 15447",
    transform: "translate(910 120.129)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 -.129)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(6 -.129)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    className: "cls-2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(12 -.129)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot);
export default __webpack_public_path__ + "static/media/ThreeDot.e9539649.svg";
export { ForwardRef as ReactComponent };